import {
  Button,
  ImageList,
  ImageListItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";

import project1 from "assets/project-1.jpg";
import project2 from "assets/project-2.jpg";
import project3 from "assets/project-3.jpg";
import project4 from "assets/project-4.jpg";
import drexelSquarePlaza from "assets/drexel-square-philadelphia-3.jpg";
import drexelSquareBench from "assets/drexel-square-philadelphia-5.jpg";
import drexelSquareSteps from "assets/drexel-square-philadelphia-6.jpg";
import drexelSquareNight from "assets/drexel-square-philadelphia-7.jpg";
import parliamentSquare1 from "assets/parliament-square-westminster-abbey-1.jpg";
import parliamentSquare2 from "assets/parliament-square-westminster-abbey-2.jpg";
import parliamentSquare7 from "assets/parliament-square-westminster-abbey-7.jpg";
import ariaHotelLobby from "assets/aria-hotel-las-vegas-lobby.jpg";
import ariaHotelSteps from "assets/aria-hotel-las-vegas-cafe-ole-steps.jpg";
import ariaHotelLightBase from "assets/aria-hotel-las-vegas-coffee-bar-light-base.jpg";
import seaweedUk from "assets/seaweed-uk.jpg";
import slateTierPanel from "assets/slate-ledge-panel-uk-tier-panel.jpg";
import slateWoodberryDown from "assets/slate-woodberry-down-n4-tier-slate.jpg";
import cambridgeStationEntrance from "assets/cambridge-station-entrance.jpg";
import cambridgeStreetPaving from "assets/cambridge-street-paving.jpg";
import cambridgeStationSquare from "assets/cambridge-station-square-paving.jpg";

const itemData = [
  {
    img: project1,
    title: "St. Paul Church, Nampa, Idaho, USA — Sandstone",
  },
  {
    img: project2,
    title: "Memorial, United Kingdom — Granite",
  },
  {
    img: project3,
    title: "London, United Kingdom — Granite",
  },
  {
    img: project4,
    title: "London, United Kingdom — Granite",
  },
];

const drexelPhotos = [
  {
    img: drexelSquarePlaza,
    alt: "Drexel Square Project, Philadelphia — Granite plaza with patterned lawn and glass tower",
  },
  {
    img: drexelSquareBench,
    alt: "Drexel Square Project, Philadelphia — Granite curved bench and wall with yellow umbrellas",
  },
  {
    img: drexelSquareSteps,
    alt: "Drexel Square Project, Philadelphia — Granite steps and curved wall",
  },
  {
    img: drexelSquareNight,
    alt: "Drexel Square Project, Philadelphia — Granite bench at night, illuminated, with paving",
  },
];

const ariaPhotos = [
  {
    img: ariaHotelLobby,
    alt: "Aria Hotel, Las Vegas — Brown Limestone lobby wall",
  },
  {
    img: ariaHotelSteps,
    alt: "Aria Hotel, Las Vegas — Wooden Vein Limestone Cafe Ole steps",
  },
  {
    img: ariaHotelLightBase,
    alt: "Aria Hotel, Las Vegas — Wooden Vein Limestone light base in the coffee bar",
  },
];

const parliamentPhotos = [
  {
    img: parliamentSquare1,
    alt: "Parliament Square — Westminster Abbey, London — Black Basalt paving with Parliament building behind",
  },
  {
    img: parliamentSquare2,
    alt: "Parliament Square — Westminster Abbey, London — Black Basalt paving, large paved square with equestrian statue and Parliament tower",
  },
  {
    img: parliamentSquare7,
    alt: "Parliament Square — Westminster Abbey, London — Black Basalt paving in front of Westminster Abbey",
  },
];

function HomeProjectShowcase() {
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <div className="px-2 flex flex-col container m-auto">
      <ImageList cols={matches ? 4 : 2} rowHeight={400}>
        {itemData.map((item) => (
          <ImageListItem key={item.img}>
            <img
              src={item.img}
              alt={item.title}
              className="object-cover w-full h-full rounded-lg"
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-2">
        {itemData.map((item) => (
          <Typography key={item.title} variant="body2" className="text-center">
            {item.title}
          </Typography>
        ))}
      </div>

      <Typography variant="h6" className="text-center mt-10 mb-2">
        Drexel Square Project, Philadelphia — Granite
      </Typography>
      <ImageList cols={matches ? 4 : 2} rowHeight={300}>
        {drexelPhotos.map((item) => (
          <ImageListItem key={item.img}>
            <img
              src={item.img}
              alt={item.alt}
              className="object-cover w-full h-full rounded-lg"
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>

      <Typography variant="h6" className="text-center mt-10 mb-2">
        Parliament Square — Westminster Abbey, London — Black Basalt Paving
      </Typography>
      <ImageList cols={matches ? 4 : 2} rowHeight={300}>
        {parliamentPhotos.map((item) => (
          <ImageListItem key={item.img}>
            <img
              src={item.img}
              alt={item.alt}
              className="object-cover w-full h-full rounded-lg"
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>

      <Typography variant="h6" className="text-center mt-10 mb-2">
        Aria Hotel, Las Vegas
      </Typography>
      <ImageList cols={matches ? 4 : 2} rowHeight={300}>
        {ariaPhotos.map((item) => (
          <ImageListItem key={item.img}>
            <img
              src={item.img}
              alt={item.alt}
              className="object-cover w-full h-full rounded-lg"
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mt-2">
        <Typography variant="body2" className="text-center">
          Lobby — Brown Limestone
        </Typography>
        <Typography variant="body2" className="text-center">
          Cafe Ole Steps — Wooden Vein Limestone
        </Typography>
        <Typography variant="body2" className="text-center">
          Coffee Bar Light Base — Wooden Vein Limestone
        </Typography>
      </div>

      <Typography variant="h6" className="text-center mt-10 mb-2">
        Seaweed, UK — Granite
      </Typography>
      <ImageList cols={matches ? 4 : 2} rowHeight={300}>
        <ImageListItem>
          <img
            src={seaweedUk}
            alt="Seaweed, UK — Granite seaside promenade paving in a seaweed pattern"
            className="object-cover w-full h-full rounded-lg"
            loading="lazy"
          />
        </ImageListItem>
      </ImageList>

      <Typography variant="h6" className="text-center mt-10 mb-2">
        Slate Ledge Panel, UK
      </Typography>
      <ImageList cols={matches ? 4 : 2} rowHeight={300}>
        <ImageListItem>
          <img
            src={slateTierPanel}
            alt="Panel, UK — Slate ledge panel wall"
            className="object-cover w-full h-full rounded-lg"
            loading="lazy"
          />
        </ImageListItem>
        <ImageListItem>
          <img
            src={slateWoodberryDown}
            alt="Woodberry Down Housing Development, N4, UK — Slate ledge panel water feature"
            className="object-cover w-full h-full rounded-lg"
            loading="lazy"
          />
        </ImageListItem>
      </ImageList>
      <div className="grid grid-cols-2 md:grid-cols-2 gap-2 mt-2">
        <Typography variant="body2" className="text-center">
          Panel, UK — Slate
        </Typography>
        <Typography variant="body2" className="text-center">
          Woodberry Down Housing Development, N4, UK — Slate
        </Typography>
      </div>

      <Typography variant="h6" className="text-center mt-10 mb-2">
        Cambridge Railway Station, UK — Granite Paving
      </Typography>
      <ImageList cols={matches ? 4 : 2} rowHeight={300}>
        <ImageListItem>
          <img
            src={cambridgeStationEntrance}
            alt="Cambridge Railway Station entrance, UK — Granite paving"
            className="object-cover w-full h-full rounded-lg"
            loading="lazy"
          />
        </ImageListItem>
        <ImageListItem>
          <img
            src={cambridgeStreetPaving}
            alt="Cambridge street, UK — Granite paving"
            className="object-cover w-full h-full rounded-lg"
            loading="lazy"
          />
        </ImageListItem>
        <ImageListItem>
          <img
            src={cambridgeStationSquare}
            alt="Cambridge Station Square, UK — Granite paving"
            className="object-cover w-full h-full rounded-lg"
            loading="lazy"
          />
        </ImageListItem>
      </ImageList>

      <Typography className="text-center my-10 uppercase text-3xl">
        From Landscaping to Kitchen Countertops
      </Typography>

      <Button
        component={Link}
        to="/catalogue"
        variant="contained"
        color="brand"
        size="large"
        className="m-auto"
      >
        View Our Catalogue
      </Button>
    </div>
  );
}

export default HomeProjectShowcase;
